module.exports = __webpack_public_path__ + "static/media/bannerimg04.531d6dd3.jpg";